module.exports = __webpack_public_path__ + "static/media/blog-cover.4c47abad.png";